export const ProToPatientValidator = {
  0: () => true,

  //    Step 1: Basics (Simplified: No birthday/birthplace check)
  1: (data) => {
    const checks = {
        hasSex: data.sex !== 0 && data.sex !== null,
        minHeight: data.height > 40,
        minWeight: data.weight > 2,
        hasOccupation: data.occupation?.trim() !== "",
        hasMaritalStatus: data.marital_status !== 0 && data.marital_status !== null,
        hasScholarship: data.scholarship !== 0 && data.scholarship !== null
    };
    return Object.values(checks).every(Boolean);
  },

  //    Step 2: Substance Use
  2: (data) => {
    const details = data.substances.substances_detail;
    if (details.length === 0) return true;
    return details.every(item => item.substance !== "" && item.year_start?.toString().length === 4);
  },

  //    Step 3: General Health
  3: (data) => {
    const checks = {
        fitnessValid: data.fitness.level !== null,
        mealsValid: data.diet.meals_per_day > 0,
        // If sexual health is active, partners and protection must be set
        sexualHealthValid: !data.sexual_health.status || (data.sexual_health.protection !== null)
    };
    return Object.values(checks).every(Boolean);
  }
};